<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>图书管理->借书证号</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 列表数据 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:80px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:200px;">
                        <el-cascader
                            :options="depts"
                            v-model="form.deptId"
                            placeholder="请选择机构名称"
                            :props="props"
                            collapse-tags
                            clearable></el-cascader>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.repeatName" clearable>
                            <el-option
                                v-for="item in names"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.borrowBookNumber" placeholder="借书证号"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                    <el-button type="warning" icon="search" @click="synchron" >同步借书证号</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width:100%;margin-bottom:20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                default-expand-all>
                <el-table-column type="index" label="序号" width="55px" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name"  label="姓名" :show-overflow-tooltip="true" width="100px" >
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showData(scope.row)">{{scope.row.name}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="sex" label="性别"  width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sex == 0">
                            未知
                        </div>
                        <div v-else-if="scope.row.sex == 1">
                            男
                        </div>
                        <div v-else-if="scope.row.sex == 2">
                            女
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="identityCard" label="身份证" :show-overflow-tooltip="true" width="150px" ></el-table-column>
                 <el-table-column prop="personType" label="人员类型" width="80px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.personType == 1">
                            学生
                        </div>
                        <div v-else-if="scope.row.personType == 2">
                            教职
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="deptIdstrName" label="机构名称" :show-overflow-tooltip="true" width="100px"> </el-table-column>
                <el-table-column prop="borrowBookNumber" label="借书证号" :show-overflow-tooltip="true"> </el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改借书证号</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        
        <!--详情 -->
        <div v-if="userDetailsVisible">
            <userDetails ref="userDetails"></userDetails>
        </div>
        <!-- 修改借书证号-->
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../common/http';
    import userDetails from './UserDetails.vue';
    import update from './Update.vue';

    export default {
        name:"BorrowBookNumber",
        data(){
            return{
                userDetailsVisible:false,
                updateVisible:false,
                loading:false,
                loadingText:"",
                props: { multiple: true,  checkStrictly: true },
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    deptId:[],
                    repeatName:"",
                    name:"",
                    identityCard:"",
                    borrowBookNumber:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                names:[{
                    value:'',
                    label:'全部姓名'
                },{
                    value:1,
                    label:'姓名不重名'
                },{
                    value:2,
                    label:'姓名重名'
                }]
            }
        },
        components: {
            userDetails,update
        },
        created:function () {
            this.getDeptData();
            // 用户信息
            // let userinfo =JSON.parse(sessionStorage.getItem('userinfo'));
            // if(userinfo != null && userinfo!=""){
            //     // 如果id为1的话，表示管理员，管理才能同步操作
            //     // if(userinfo.id == 1){
            //         this.form.isShowSynchron=true;
            //     // }else{
            //         // this.form.isShowSynchron=false;
            //     // }
            // }
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = res.data.selects;
                      this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中...";

                let deptIdArr=new Array();
                for(let i=0;i<this.form.deptId.length;i++){
                    let deptId=this.form.deptId[i];
                    deptIdArr.push(deptId[deptId.length-1]);
                }

                let url  = this.listUserBookNumberUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    repeatName:this.form.repeatName,
                    name:this.form.name,
                    identityCard:this.form.identityCard,
                    borrowBookNumber:this.form.borrowBookNumber,
                    deptId:deptIdArr.join(","),
                };       
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.users;
                        this.common.total=res.data.total;
                        this.loading=false;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                        this.loading=false;
                    }
                },(err)=>{
                    this.loading=false;
                });
            },
            synchron(){
                let msg="该操作直接从图书馆同步人员借书证号，同步时间会比较久需要等待几分钟，并且会直接覆盖当前设置是否继续？";
                this.$commonFn.showConfirm2(msg,this.synchronData);
            },
            synchronData(){
                this.loadingText="正在同步中...";
                this.loading=true;

                let url  = this.synchronUserBookNumberUrl;
                let data = {
                };  
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.getData();
                        this.loading=false;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                        this.loading=false;
                    }
                },(err)=>{
                    this.loading=false;
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            showData(row){
                // 触发详情界面
                this.userDetailsVisible = true;
                this.$nextTick(() => {
                    let url  = this.getUserByIdUrl;
                    let data = {
                        id:row.id
                    };       
                    // console.log(JSON.stringify(data))
                    this.apiPost(url,data).then((res) => {
                        if(res.status==200){
                            this.$refs['userDetails'].init(res.data);
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                    });
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/library/BorrowBookNumber.vue